<template>
  <section v-loading="pageLoading">
   <!--  <el-row v-if="currentApp.allow_create_user > 0" class="content-top">
     <el-button @click="add = true">{{ $t('pages.hamlet_users.add_user') }}</el-button>
   </el-row> -->
    <el-row class="content-top" v-if="currentApp">
      {{ $t('pages.hamlet_users.select_app') }}
      <el-select v-model="currentApp" filterable>
        <el-option
          v-for="app in apps"
          :label="app.name"
          :value="app"
          :key="app.name">
          {{ app.name }}
        </el-option>
      </el-select>

      <el-button
        @click="toCreateUser"
        style="margin-left:20px"
        type="primary"
        v-if="currentApp.allow_create_user">
        <i class="el-icon-plus"></i>
        {{ $t('pages.hamlet_users.add_user') }}
      </el-button>

      <!-- search bar float right -->
      <el-row
        class="page-toolbar__group--right">
        <el-input
          icon="search"
          v-model.trim="tableCfg.search"
          :placeholder="$t('pages.hamlet_users.searchPlaceholder')">
        </el-input>
      </el-row>
    </el-row>

    <el-row>
      <el-table :data="currentUsers"
        @sort-change="handleSortChange"
        :default-sort="{ prop: 'id', order: 'ascending' }">
        <el-table-column
          prop="id"
          width="100"
          sortable="custom"
          :label="$t('pages.hamlet_users.id')">
        </el-table-column>
        <el-table-column
          prop="username"
          width="130"
          sortable="custom"
          :label="$t('pages.hamlet_users.username')">
        </el-table-column>
        <el-table-column
          prop="email"
          min-width="150"
          sortable="custom"
          :label="$t('pages.hamlet_users.email')">
        </el-table-column>
        <el-table-column
          prop="role"
          width="100"
          :label="$t('pages.hamlet_users.role')">
        </el-table-column>
        <el-table-column
          prop="last_login_at"
          width="160"
          align="center"
          :label="$t('pages.hamlet_users.last_login_at')"
          :formatter="formatDatetime">
        </el-table-column>
        <el-table-column
          prop="status"
          width="120"
          align="center"
          :label="$t('pages.hamlet_users.status')">
          <template slot-scope="scope"
        >
            {{ scope.row.status }}
          </template>
        </el-table-column>
        <el-table-column
          prop="thirdparty_users"
          min-width="100"
          :label="$t('pages.hamlet_users.thirdparty_users')">
          <template slot-scope="scope">
            <div
              v-for="type in Object.keys(scope.row.thirdparty_users)"
              :key="type"
            >
              <el-popover
                placement="right"
                trigger="click"
              >
                <el-button
                  slot="reference"
                  type="text"
                  :key="type"
                >
                  {{ $t(`common.${type}`) }}
                </el-button>
                <pre>{{ scope.row.thirdparty_users[type] }}</pre>
              </el-popover>
              <el-button
                type="text"
                @click="toUnbindUserAccount(scope.row, type)"
              >解绑</el-button>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          min-width="100"
          align="center"
          :label="$t('common.operation')">
          <template slot-scope="scope">
            <el-button
              type="text"
              @click="resetPassword(scope.row)">
              {{ $t('common.resetPassword') }}
            </el-button>
            <el-button
              type="text"
              @click="popUpEditUserDialog(scope.row)"
              v-if="scope.row.is_active">
              {{ $t('common.edit') }}
            </el-button>
            <el-button
              type="text"
              @click="activeUser(scope.row)"
              v-if="scope.row.is_active">
              {{ $t('common.forbid') }}
            </el-button>
            <el-button
              type="text"
              @click="activeUser(scope.row)"
              v-else>
              {{ $t('common.active') }}
            </el-button>
            <el-button
              type="text"
              @click="unlockUser(scope.row)"
              v-if="scope.row.is_locked && scope.row.is_active">
              {{ $t('common.unlock') }}
            </el-button>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination
        class="table-wrapper__pagination"
        layout="sizes, total, prev, pager, next"
        @current-change="handleUsersCurPageChange"
        @size-change="handleUsersSizeChange"
        :page-sizes="tableCfg.pageSizes"
        :total="usersTotal">
      </el-pagination>
    </el-row>

    <!-- edit user -->
    <el-dialog v-model="editDialog" :title="$t('common.edit')">
      <el-form :model="editUserForm"
        label-width="140px">
        <el-form-item :label="$t('pages.hamlet_users.username')">
          {{ editUserForm.username }}
        </el-form-item>
        <el-form-item :label="$t('pages.hamlet_users.email')" prop="email">
          {{ editUserForm.email }}
        </el-form-item>
        <el-form-item :label="$t('pages.hamlet_users.role')">
          <el-input
            v-model="editUserForm.role"
            type="text"
          ></el-input>
        </el-form-item>
        <el-form-item :label="$t('pages.hamlet_users.tel')">
          <el-input
            v-model="editUserForm.tel"
            type="text"
          ></el-input>
        </el-form-item>
        <el-form-item :label="$t('pages.hamlet_users.forceLoginSms')">
          <el-checkbox v-model="editUserForm.force_sms" :label="$t('common.yes')"></el-checkbox>
        </el-form-item>
        <el-form-item>
          <el-button
            @click="submitEditUser"
            type="primary">
            {{ $t('common.save') }}
          </el-button>
        </el-form-item>
      </el-form>
    </el-dialog>

    <!-- add user -->
    <el-dialog
      v-model="add"
      v-if="currentApp && currentApp.allow_create_user"
      @close="resetAdd"
      :title="$t('pages.hamlet_users.add_user')"
    >
      <el-form
        :model="addUser"
        ref="addForm"
        :rules="addUserRules"
        label-width="140px">
        <el-form-item
          :label="$t('pages.hamlet_users.app_name')">
          {{ currentApp.name }}
        </el-form-item>
        <el-form-item
          :label="$t('common.username')"
          prop="username">
          <el-input
            v-model="addUser.username"
            @blur="checkUsername"></el-input>
        </el-form-item>
        <el-form-item
          :label="$t('common.email')"
          prop="email">
          <el-input
            v-model="addUser.email"
            @blur="checkEmail"></el-input>
        </el-form-item>
        <template v-if="!usernameIsExist && !emailIsExist">
          <el-form-item
            :label="$t('common.role')"
            prop="role">
            <el-input v-model="addUser.role"></el-input>
          </el-form-item>
          <el-form-item
            :label="$t('common.password')"
            prop="password">
            <el-input
              v-model="addUser.password"
              type="password"></el-input>
          </el-form-item>
          <el-form-item class="random-psw">
            <el-button
              type="text"
              @click="createRandomPassword()">
              {{ $t('common.random_password') }}
            </el-button>
            <code>{{ this.randomPassword }}</code>
          </el-form-item>
          <el-form-item
            :label="$t('common.confirmPassword')"
            prop="confirm_password">
            <el-input
              v-model="addUser.confirm_password"
              type="password"
              @keyup.enter.native="submitAddUser"></el-input>
          </el-form-item>
          <el-form-item :label="$t('pages.hamlet_users.tel')">
            <el-input
              v-model="addUser.tel"
              type="text"
            ></el-input>
          </el-form-item>
          <el-form-item :label="$t('pages.hamlet_users.forceLoginSms')">
            <el-checkbox v-model="addUser.force_sms" :label="$t('common.yes')"></el-checkbox>
          </el-form-item>
        </template>
        <el-form-item>
          <el-button
            @click="submitAddUser"
            :disabled="!this.addUser.username && !this.addUser.email"
            type="primary">
            {{ $t('common.save') }}
          </el-button>
        </el-form-item>
      </el-form>
    </el-dialog>

    <!-- reset password -->
    <el-dialog
      v-model="reset"
      @close="clearResetform"
      :title="$t('common.resetPassword')"
      class="dialog-resetpsw">
      <el-form
        :model="userReset"
        ref="resetForm"
        :rules="resetPasswordRules"
        label-width="100px">
        <el-form-item
          :label="$t('common.username')"
          prop="username" >
          {{ userReset.username }}
        </el-form-item>
        <el-form-item
          :label="$t('common.password')"
          prop="password">
          <el-input
            v-model="userReset.password"
            type="password"></el-input>
          <el-row class="random-psw">
            <el-button
              type="text"
              @click="createRandomPassword()">
              {{ $t('common.random_password') }}
            </el-button>
            <code>{{ this.randomPassword }}</code>
          </el-row>
        </el-form-item>
        <el-form-item
          :label="$t('common.confirmPassword')"
          prop="confirm_password">
          <el-input
            v-model="userReset.confirm_password"
            type="password"
            @keyup.enter.native="submitResetPassword"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button
            @click="submitResetPassword"
            type="primary">
            {{ $t('common.save') }}
          </el-button>
        </el-form-item>
      </el-form>

    </el-dialog>
  </section>
</template>

<script>
  import { getValueByPath, compare, compareIgnoreCase } from '@/utils/index';

  export default {
    name: 'AppUsers',
    data() {
      /* eslint-disable */
      const ptn = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      const pwValidator = (rule, value, cb) => {
        const ptn = this.$consts.PASSWORD_REGEXP;
        if (value.trim() === '') {
          cb(new Error(this.$t('common.passwordPlaceholder')));
        } else if (!ptn.test(value)) {
          cb(new Error(this.$t('rules.password_format')));
        } else {
          cb();
        }
      };
      const pwConfirmValidator = (rule, value, cb) => {
        let form;
        if (this.add) form = 'addUser';
        if (this.reset) form = 'userReset';
        if (value.trim() === '') {
          cb(new Error(this.$t('common.passwordPlaceholder')));
        } else if (form.length && value !== this[form].password) {
          cb(new Error(this.$t('rules.password_repeat')));
        } else {
          cb();
        }
      };
      const emailValidator = (rule, value, cb) => {
        if (!value || value.trim() === '') {
          cb();
        } else if (this.addUser.username && this.originalEmail !== '' &&
          this.addUser.email !== this.originalEmail) {
          if (!this.originalEmail) {
            cb(new Error(this.$t('pages.hamlet_users.emailIsEmpty', { username: this.addUser.username })));
          }

          cb(new Error(this.$t('pages.hamlet_users.emailNotMatch', { name: this.originalEmail })));
        } else if (!this.emailRegexp.test(value)) {
          cb(new Error(this.$t('rules.email')));
        } else if (this.curEmails.indexOf(value.trim()) >= 0) {
          cb(new Error(this.$t('rules.has_email')));
        } else {
          cb();
        }
      };
      const usernameValidator = (rule, value, cb) => {
        if (!value || value.trim() === '') {
          cb();
        } else if (this.curUsernames.indexOf(value.trim()) >= 0) {
          cb(new Error(this.$t('rules.has_username')));
        } else if (this.addUser.email && this.originalUsername !== '' &&
          this.addUser.username !== this.originalUsername) {
          if (!this.originalUsername) {
            cb(new Error(this.$t('pages.hamlet_users.usernameIsEmpty')));
          }

          cb(new Error(this.$t('pages.hamlet_users.usernameNotMatch', { name: this.originalUsername })));
        } else {
          cb();
        }
      };

      return {
        pageLoading: false,
        emailRegexp: ptn,
        apps: [],
        allowCreateUserApps: [],
        users: [],
        currentApp: {},
        add: false,
        reset: false,
        randomPassword: '',
        tableCfg: {
          order: null,
          search: '',
          pageSizes: [20, 50, 100],
          pager: {
            pageSize: 20,
            currentPage: 1,
          },
          dateFormat: 'YYYY-MM-DD HH:mm:ss',
        },
        editDialog: false,
        editUserForm: {
          id: null,
          username: '',
          email: '',
          role: '',
          force_sms: false,
          tel: '',
        },
        addUser: {
          username: '',
          email: '',
          role: '',
          password: '',
          confirm_password: '',
          force_sms: false,
          tel: '',
        },
        usernameIsValid: false,

        // 用户名在系统中已存在，此时不需要输入密码
        usernameIsExist: false,
        originalUsername: '',
        emailIsValid: false,

        // 邮箱在系统中已存在
        emailIsExist: false,
        originalEmail: '',
        userReset: {
          username: '',
          id: '',
          password: '',
          confirm_password: '',
        },
        requireEmail: false,
        addUserRules: {
          username: [
            { required: false, validator: usernameValidator },
          ],
          email: [
            { required: false, validator: emailValidator }
          ],
          password: [
            { required: true, validator: pwValidator },
          ],
          confirm_password: [
            { required: true, validator: pwConfirmValidator },
          ],
        },
        resetPasswordRules: {
          password: [
            { required: true, validator: pwValidator },
          ],
          confirm_password: [
            { required: true, validator: pwConfirmValidator },
          ],
        },
        thirdpartyInfo: {},
      };
    },
    computed: {
      curEmails() {
        return this.users.map(u => u.email);
      },
      curUsernames() {
        return this.users.map(u => u.username);
      },
      filteredUsers() {
        let users = [...this.users];

        if (this.tableCfg.search) {
          users = users.filter(
            user => ((user.username.toLowerCase().indexOf(this.tableCfg.search.toLowerCase()) !== -1) ||
                     (user.email.toLowerCase().indexOf(this.tableCfg.search.toLowerCase()) !== -1)));
        }

        if (this.tableCfg.order) {
          const _order = this.tableCfg.order.order === 'ascending';

          users.sort((a, b) => {
            const _a = getValueByPath(a, this.tableCfg.order.prop);
            const _b = getValueByPath(b, this.tableCfg.order.prop);
            return _order ? compare(_a, _b) : compare(_b, _a);
          });
        }

        return users;
      },
      currentUsers() {
        const start = (this.tableCfg.pager.currentPage - 1) * this.tableCfg.pager.pageSize;
        const end = this.tableCfg.pager.currentPage * this.tableCfg.pager.pageSize;
        return this.filteredUsers.slice(start, end);
      },
      usersTotal() {
        return this.filteredUsers.length;
      },
    },
    watch: {
      currentApp(val) {
       if (val && val.id) {
        this.fetchAppUsers(val.id);
        this.fetchAuthSetting(val.id);
       }
       // 重置tableCfg
       this.tableCfg.search = '';
       this.tableCfg.pager.currentPage = 1;
       this.tableCfg.pager.pageSize = 20;
      /* if (val.allow_create_user) {
        this.fetchAuthSetting(val.id);
       } else {
        this.requireEmail = false;
       }*/
      },

      /* eslint-disable object-shorthand */
      'addUser.username'(newVal, oldVal) {
        if (newVal && oldVal) {
          this.originalEmail = '';
          this.$refs.addForm.validateField('email');
        }
      },
      'addUser.email'(newVal, oldVal) {
        if (newVal && oldVal) {
          this.originalUsername = '';
          this.$refs.addForm.validateField('username');
        }
      },
    },
    methods: {
      createRandomPassword() {
        this.randomPassword = this.$utils.randomPassword();
        this.addUser.password = this.randomPassword;
        this.addUser.confirm_password = this.randomPassword;
        this.userReset.password = this.randomPassword;
        this.userReset.confirm_password = this.randomPassword;
      },
      toCreateUser() {
        this.addUser.force_sms = false;
        this.addUser.tel = '';
        this.add = true;
      },
      handleSortChange({ column, prop, order }) {
        this.tableCfg.order = column ? { prop, order } : null;
      },
      handleUsersCurPageChange(currentPage) {
        this.tableCfg.pager.currentPage = currentPage;
      },
      handleUsersSizeChange(pageSize) {
        this.tableCfg.pager.pageSize = pageSize;
      },
      popUpEditUserDialog(row) {
        Object.assign(this.editUserForm, {
          id: row.id,
          username: row.username,
          email: row.email,
          role: row.role,
          force_sms: row.force_sms,
          tel: row.tel,
        });
        this.editDialog = true;
      },
      resetAdd() {
        this.clearPassword();
        this.$refs.addForm.resetFields();
        this.usernameIsValid = false;
        this.usernameIsExist = false;
        this.emailIsValid = false;
        this.emailIsExist = false;
        this.originalUsername = '';
        this.originalEmail = '';
      },
      clearResetform() {
        this.clearPassword();
        this.$refs.resetForm.resetFields();
      },
      clearPassword() {
        this.randomPassword = '';
      },
      formatDatetime(r, c) {
        const ds = r[c.property];
        return ds ? this.$moment(ds).utcOffset(+960).format('YYYY/M/DD HH:mm:ss') : '';
      },
      fetchApps() {
        this.$api.listApps().then((res) => {
          // this.apps = res.data.applications;
          this.apps = res.data.applications.filter(app => app.name !== 'Hamlet');
          this.currentApp = this.apps[0];
        });
      },
      fetchAppUsers(id) {
        this.pageLoading = true;
        this.$api.fetchAppUsers(id)
          .then((res) => {
            const cleaningRecords = [];
            for (let i = 0, len = res.data.users.length; i < len; i += 1) {
              const record = Object.assign({}, res.data.users[i]);  // copy object. avoid vuex outside change error
              if (!record.is_active) {
                record.status = this.$t('pages.hamlet_users.inactive');
              } else if (record.is_locked) {
                record.status = this.$t('pages.hamlet_users.locked');
              } else {
                record.status = this.$t('pages.hamlet_users.normal');
              }
              record.username = record.username || '';  // 方便搜索、排序  部分用户名字为空
              record.email = record.email || '';  // 方便搜索、排序
              cleaningRecords.push(record);
            }
            this.users = cleaningRecords;
          })
          .finally(() => {
            this.pageLoading = false;
          });
      },
      fetchAuthSetting(id) {
        this.$api.fetchAppAuthSetting(id)
          .then((res) => {
            // this.requireEmail = res.data.auth_settings.require_email;
            // this.addUserRules.email[0].required = this.requireEmail;
          });
      },
      addAppUser() {
        this.$api.addAppUser(this.currentApp.id, this.addUser)
          .then(() => {
            this.add = false;
            this.fetchAppUsers(this.currentApp.id);
          })
          .catch((res) => {
            console.log('res', res);
            this.$message,error(this.$t('common.addFailed'));
          });
      },
      editUser(id, param) {
        return this.$api.editUser(id, param).then((res) => {
          this.fetchAppUsers(this.currentApp.id);
        });
      },
      unlock(id) {
        this.$api.unlockUser(id).then((res) => {
          this.fetchAppUsers(this.currentApp.id);
        });
      },
      changeUserPassword() {
        this.$api.changeUserPassword(this.userReset.id, {
          password: this.userReset.password,
          confirm_password: this.userReset.confirm_password,
        }).then((res) => {
          this.reset = false;
        });
      },
      resetPassword(row) {
        Object.assign(this.userReset, {
          username: row.username,
          id: row.id,
        });
        this.reset = true;
      },
      submitAddUser() {
        this.$nextTick(() => {
          this.$refs.addForm.validate((validate) => {
            if (validate) {
              this.$api.userIsExist({
                username: this.addUser.username,
                email: this.addUser.email,
              }).then(() => {
                this.usernameIsExist = false;
                this.emailIsExist = false;
                this.$nextTick(() => {
                  this.$refs.addForm.validate((validate) => {
                    if (validate) {
                      this.addAppUser();
                    }
                  });
                });
              }).catch((res) => {
                const data = res.body.data;
                this.$nextTick(() => {
                  if ((!this.addUser.username || data.user.username ===  this.addUser.username) &&
                    (!this.addUser.email || !compareIgnoreCase(data.user.email, this.addUser.email))) {
                    this.addAppUser();
                  }
                });
              });
            }
          });
        });
      },
      submitEditUser() {
        // no need validate, email and role can be null
        this.editUser(this.editUserForm.id, {
          role: this.editUserForm.role,
          force_sms: this.editUserForm.force_sms,
          tel: this.editUserForm.tel,
        }).then(() => {
          this.editDialog = false;
        });
      },
      submitResetPassword() {
        this.$refs.resetForm.validate((validate) => {
          if (validate) {
            this.changeUserPassword();
          }
        });
      },
      unlockUser(row) {
        this.$msgbox.confirm(this.$t('verify.unlock_user', {'username': row.username}), this.$t('common.unlock'), {
          confirmButtonText: this.$t('common.confirm'),
          cancelButtonText: this.$t('common.cancel'),
        }).then(() => {
          this.unlock(row.id);
        });
      },
      activeUser(row) {
        const message = row.is_active ? 'verify.forbid_user' : 'verify.active_user';
        const title = row.is_active ? 'common.forbid' : 'common.active';
        this.$msgbox.confirm(this.$t(message, {'username': row.username}), this.$t(title), {
          confirmButtonText: this.$t('common.confirm'),
          cancelButtonText: this.$t('common.cancel'),
        }).then(() => {
          this.editUser(row.id, { is_active: !row.is_active }).catch(res=>{
          if(res.data.err_code === "01A0106"){
            console.log(1);
            this.$message.error('该用户已被停用，如需启用，请先前往Hamlet 2的Hamlet 1用户管理界面启用');
          }
        });;
        });
      },
      showThirdpartyInfo(val) {
      },
      checkUsername() {
        this.usernameIsValid = !!(this.addUser.username && !this.users.find(user => user.username === this.addUser.username));
        if (!this.usernameIsValid) {
          // this.originalUsername = '';
          this.originalEmail = '';
          this.usernameIsExist = false;
        }

        this.$refs.addForm.validateField('username');
        this.$refs.addForm.validateField('email');
        if (this.usernameIsValid) {
          this.$api.userIsExist({
            username: this.addUser.username,
          })
          .then((val) => {
            this.usernameIsExist = false;
            this.originalEmail = '';
          })
          .catch((res) => {
            console.log('res', res.body.data);
            const data = res.body.data;

            // this.originalUsername = data.user.username;
            this.originalEmail = data.user.email;

            // 仅邮箱为空时，自动填充
            if (!this.addUser.email || !compareIgnoreCase(data.user.email, this.addUser.email)) {
              this.addUser.email = data.user.email;
              this.emailIsValid = true;
              this.emailIsExist = true;
            }

            this.usernameIsExist = true;
          })
          .finally(() => {
            // this.$refs.addForm.validateField('email');
            this.$refs.addForm.validate();
          });
        }
      },
      checkEmail() {
        this.emailIsValid = !!(this.addUser.email &&
          this.emailRegexp.test(this.addUser.email) &&
          !this.users.find(user => user.email === this.addUser.email));
        if (!this.emailIsValid) {
          // this.originalEmail = '';
          this.originalUsername = '';
          this.emailIsExist = false;
        }

        this.$refs.addForm.validateField('username');
        this.$refs.addForm.validateField('email');
        if (this.emailIsValid) {
          this.$api.userIsExist({
            email: this.addUser.email,
          })
          .then(() => {
            this.emailIsExist = false;
            this.originalUsername = '';
          })
          .catch((res) => {
            const data = res.body.data;

            this.originalUsername = data.user.username;
            // this.originalEmail = data.user.email;

            // 仅邮箱为空时，自动填充
            if (!this.addUser.username ||
              (data.user.username === this.addUser.username)) {
              this.addUser.username = data.user.username;
              this.usernameIsValid = true;
              this.usernameIsExist = true;
            }

            this.emailIsExist = true;
          })
          .finally(() => {
            this.$refs.addForm.validate();
          });
        }
      },
      toUnbindUserAccount(user, type) {
        this.$api.unbindUserAccount({
          app_id: this.currentApp.id,
          user_id: user.user_id,
          type,
        })
          .then(() => {
            this.$message.success('已解绑');
            this.fetchAppUsers(this.currentApp.id);
          })
          .catch((err) => {
            console.log('>>>解绑失败>>>', err);
            this.$message.error('解绑失败');
          });
      },
    },
    created() {
      this.fetchApps();
    },
  };
</script>



// WEBPACK FOOTER //
// AppUsers.vue?0121d349